import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Button, DialogActions, DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { handleDeleteB2CUser } from '../../handler/CustomerListInCorporationHandler';
import './ConfirmDeleteAdditionUserDialog.css';
import { handleDeleteProjectB2CUser } from '../../handler/CustomerListInProjectHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ConfirmDeleteAdditionUserDialog({argsAll, parentScreen}) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    let userIndexInAddList = Utils.findIndexInArrayById(argsAll.isOpenDialogConfirmDelete.userId, argsAll?.userAddList);
    let userIndexInCustomerList = Utils.findIndexInArrayById(argsAll.isOpenDialogConfirmDelete.userId, argsAll?.customerList);

    const handleAgree = () => {
        if (!argsAll.isOpenDialogConfirmDelete.userId) {
            // console.error('Can not get user id from list!!!');
            return;
        }
        if (argsAll.isOpenDialogConfirmDelete.isEnable && argsAll.isOpenDialogConfirmDelete.userId) {
            if (userIndexInCustomerList !== -1) {
                if (parentScreen === Constant.SCREEN_LIST.B2C_IN_ORG) {
                    // Remove old B2C user in org
                    handleDeleteB2CUser(argsAll, argsAll.isOpenDialogConfirmDelete.userId);
                } else if (parentScreen === Constant.SCREEN_LIST.B2C_IN_PROJECT) {
                    // Remove old B2C user in project
                    handleDeleteProjectB2CUser(argsAll, argsAll.isOpenDialogConfirmDelete.userId, argsAll.customerList[userIndexInCustomerList].idInProject);
                }
            } else if (userIndexInAddList !== -1) {
                // Remove add new user
                argsAll.reMoveRowProjectUser(
                    argsAll,
                    argsAll.isOpenDialogConfirmDelete.userId,
                    argsAll.userAddList,
                    argsAll.setUserAddList
                );
            }
        }
        argsAll.setIsOpenDialogConfirmDelete({ isEnable: false, userId: null });
    };

    const handleDisagree = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        argsAll.setIsOpenDialogConfirmDelete({ isEnable: false, userId: null });
    };

    return (
        <Dialog
            open={argsAll.isOpenDialogConfirmDelete.isEnable}
            onClose={(event, reason) => handleDisagree(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-delete-addition-user"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-delete-addition-user-content">
                    {userIndexInAddList !== -1 && trI18n('USER12MSG005')}
                    {userIndexInCustomerList !== -1 && trI18n('USER09MSG006')}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    onClick={handleAgree}
                    autoFocus
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    onClick={handleDisagree}
                    className="btn-handle-delete-user btn-handle-delete-user-disagree"
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
